/**
 * §P.3 · Las fechas de una pausa.
 *
 * **Pausar exige `paused_to`**, y el servidor responde `422 invalid_pause` sin
 * ella. La razón está escrita en el contrato y vale la pena tenerla delante:
 *
 * > Una pausa sin fecha de vuelta es una cuota que se deja de cobrar en julio y de
 * > la que nadie se acuerda en octubre; el club se entera cuando no le cuadran las
 * > cuentas del año.
 *
 * Así que el formulario **no** deja la fecha vacía: propone una. Y propone la que
 * el club iba a poner, que depende de en qué mes esté.
 */

const comoDia = (d: Date): string =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(
    d.getDate()
  ).padStart(2, '0')}`;

/** El último día del mes de una fecha. */
export const finDeMes = (d: Date): string =>
  comoDia(new Date(d.getFullYear(), d.getMonth() + 1, 0));

/**
 * La vuelta que se propone por defecto.
 *
 * De mayo a agosto, **fin de agosto**: la pausa de verano es el caso que existe, y
 * quien pausa en junio no quiere volver el 30 de junio. El resto del año, fin del
 * mes en curso, que es la pausa corta por una lesión o un viaje.
 *
 * Es una propuesta, no una imposición: el campo se puede cambiar.
 */
export function vueltaPropuesta(hoy = new Date()): string {
  const mes = hoy.getMonth(); // 0 = enero
  const esVerano = mes >= 4 && mes <= 7; // mayo … agosto

  if (esVerano) return comoDia(new Date(hoy.getFullYear(), 7, 31));
  return finDeMes(hoy);
}

/** Una pausa vale si vuelve **después** de empezar. */
export const pausaValida = (desde: string, hasta: string): boolean =>
  /^\d{4}-\d{2}-\d{2}$/.test(desde) &&
  /^\d{4}-\d{2}-\d{2}$/.test(hasta) &&
  hasta > desde;

/** Cuántos días dura, para poder decirlo en la pantalla. */
export function diasDePausa(desde: string, hasta: string): number | null {
  if (!pausaValida(desde, hasta)) return null;
  const a = new Date(`${desde}T00:00:00`);
  const b = new Date(`${hasta}T00:00:00`);
  return Math.round((b.getTime() - a.getTime()) / 86_400_000);
}
